import { ModelRepositoryAdapter } from '../../'
import { TypeOf, DependencyContainer } from '../../../'

interface CustomFactoryMethods {[className: string]: (...args) => ModelRepositoryAdapter<any> }

export class DataServiceFactory {
  constructor(
    private _dependencyContainer: DependencyContainer,
    private _customFactoryMethods: CustomFactoryMethods = {}
  ) {}

  public create<T extends ModelRepositoryAdapter<any>>(
    klass: {new(...args: any[]): T},
    ...requiredClasses: Array<TypeOf<any>>
  ): T {
    const dependencyInstances = this._dependencyContainer.getInstances(...requiredClasses)
    const strategy = this._customFactoryMethods[klass.name] || ((...deps) => new klass(...deps))
    return strategy(...dependencyInstances) as T
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/creators/data-service-factory/data-service.factory.ts